
import Vue from "vue";

import { Component } from "vue-property-decorator";

@Component({
  name: "AccessibilityButton",
})
export default class AccessibilityButton extends Vue {
  openAcessibility(): void {
    const win = window as any;
    win
      .open(
        "https://www.claro.com.br/institucional/regulatorio/acessibilidade",
        "_blank"
      )
      .focus();
  }
}
